var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgScroll1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m16.015 26.884-5.61-5.931 1.816-1.718 3.789 4.006 3.767-4.004 1.82 1.713-5.582 5.934zm10.36-2.384v-17c0-4.136-3.364-7.5-7.5-7.5h-5.75c-4.136 0-7.5 3.365-7.5 7.5v17c0 4.136 3.364 7.5 7.5 7.5h5.75c4.136 0 7.5-3.364 7.5-7.5zm-7.5-22c2.757 0 5 2.243 5 5v17c0 2.757-2.243 5-5 5h-5.75c-2.757 0-5-2.243-5-5v-17c0-2.757 2.243-5 5-5h5.75zM16 5.063a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5zm0 5a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5zm0 5a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5z",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScroll1);
export default __webpack_public_path__ + "static/media/scroll 1.1e03156ff38194c1907bbec97ecf7076.svg";
export { ForwardRef as ReactComponent };